import { Button, Modal, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

import { Link, useNavigate } from "react-router-dom";
import routes from "../../../../../requests/routes";
import axios from "../../../../../requests/axios";

export const DuplicateButton = ({ record, getPrograms }) => {
  const navigate = useNavigate();

  const onDuplicate = () => {
    Modal.confirm({
      title: `Duplicate "${record.name}"?`,
      content: "A copy will be created with ‘(Copy)’ suffix and unpublished.",
      okText: "Duplicate",
      onOk: async () => {
        try {
          const { data } = await axios.patch(
            routes.createProgram + `/${record._id}/duplicate`,
            { nameSuffix: " (Copy)", publish: false, place: "end" }
          );
          const newProgram = data?.program;
          if (!newProgram) {
            message.error("Unexpected response");
            return;
          }
          getPrograms();

          navigate(`/admin/programs/${newProgram._id}/main`);
        } catch (e) {
          message.error(e?.response?.data?.message || "Failed to duplicate");
        }
      },
    });
  };

  return (
    <Link
      variant="text"
      onClick={onDuplicate}
      style={{ display: "flex", gap: ".5rem", alignItems: "center" }}
    >
      <CopyOutlined />
      Duplicate
    </Link>
  );
};

export default DuplicateButton;
